import PropTypes from 'prop-types'
import MainButton from '../../Buttons'

const ModalFooter = ({
  leftButtons,
  rightButtons,
  closeHandler,
  clickHandler,
  children,
}) => {
  const getButtons = buttonSet => {
    return buttonSet.map((button, index) => {
      return (
        <MainButton
          key={index}
          closeHandler={closeHandler}
          clickHandler={clickHandler}
          type={button.type}
          styleType={button.style}
          label={button.label}
          size={button.size}
          isDisplayed={button.isDisplayed}
          isDisabled={button.isDisabled}
          loading={{
            isLoading: button.isLoading,
            loadingText: button.loadingText,
          }}
          customClasses={
            index < buttonSet.length - 1
              ? 'modal--spacedButton--left modal_footer_button'
              : ''
          }
          {...button.events}
        />
      )
    })
  }

  return (
    <section className="modal__footer">
      <div className="confirm__container">
        {children}
        {leftButtons.length > 0 ? getButtons(leftButtons) : ''}
      </div>

      <div className="footer__spacer" />
      <div
        className="footer__multipleButtonContainer"
      >
        {rightButtons.length > 0 ? getButtons(rightButtons) : ''}
      </div>
    </section>
  )
}

ModalFooter.defaultProps = {
  rightButtons: [],
  leftButtons: [],
  closeHandler: () => {},
  clickHandler: () => {}
}

ModalFooter.propTypes = {
  rightButtons: PropTypes.array,
  leftButtons: PropTypes.array,
  closeHandler: PropTypes.func,
  clickHandler: PropTypes.func,
  children: PropTypes.node.isRequired
}

export default ModalFooter
